import { SAVE_XEROX_CODE_FAIL, SAVE_XEROX_CODE_SUCCESS } from "./actionType";

const INIT_STATE = {
  res: [],
  error: [],
};

const Integration = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_XEROX_CODE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case SAVE_XEROX_CODE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default Integration;
